import React from 'react';
import logo from '../../assets/navbar/logo_guillespers.svg';
import email from '../../assets/social/email.svg'
import instagram from '../../assets/social/instagram.svg'
import ubicacion from '../../assets/social/ubicacion.svg'
import BackToTop from '../BackToTop/BackToTop';

import './Footer_Styles.css'

function Footer() {
    return (
        <>
        <BackToTop/>
        <footer className="footer">
            <img src={ logo } alt="logo" className="footer_logo" />
            <div className="footer_social">
                <a href="https://www.instagram.com/guillespers/" target="blank">
                    <img src={ instagram } alt="instagram" className="ig" />
                    Follow me!
                </a>
                <a href="mailto:hello@guillespers.com" className="email_mg">
                    <img src={ email } alt="email" className="email"  />
                    hello@guillespers.com
                </a>
                <a href="https://www.google.com/maps/place/Mar+del+Plata,+Provincia+de+Buenos+Aires/@-38.0175459,-57.6705736,12z/data=!3m1!4b1!4m5!3m4!1s0x9584d94d19d34209:0xdd9670804bfed126!8m2!3d-38.0054771!4d-57.5426106" target="blank">
                    <img src={ ubicacion } alt="ubicacion" className="ubi" />
                    Mar del Plata.  Argentina
                </a>
            </div>
        </footer>
        </>
    )
}

export default Footer
